import React from "react";
import { ThemeProvider as BaseThemeProvider } from "styled-components";
import { makeBaseTheme } from "./baseTheme";
import { semanticColors } from "./colors";

export const ThemeProviderWithoutStore = ({ children }: React.PropsWithChildren) => {
  const theme = makeBaseTheme(semanticColors);
  return <BaseThemeProvider theme={theme}>{children}</BaseThemeProvider>;
};
